import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddCompanyType() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/CompanyTypeLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Company Type"
      alert="Company Type Added Successfully"
      addDataAPIEndpoint="/CompanyType/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Company Type",
              name: "CT_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "CT_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        CT_Name: {
          required: true,
        },
        CT_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddCompanyType;
